import {
  AUTH_TOKEN_KEY,
  AUTH_USER_KEY,
  AUTH_REFRESH_TOKEN_KEY,
} from './constants';
import { ILoginResponse } from './types';

const storedUser = localStorage.getItem(AUTH_USER_KEY);
const storedToken = localStorage.getItem(AUTH_TOKEN_KEY);

let parsedUser: any = null;
if (storedUser) {
  try {
    parsedUser = JSON.parse(storedUser);
  } catch {
    localStorage.removeItem(AUTH_USER_KEY);
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }
}

const initialState: any = {
  splash: !parsedUser,
  user: parsedUser,
  token: storedToken || null,
  // A cached user from localStorage is untrusted until Splash re-verifies it
  // against the server (App.tsx renders <Splash/> while this is true) — on
  // a shared/borrowed device, a previous session's cached identity must
  // never be rendered without a live check first.
  isLoadingUser: !!parsedUser,
  globalLoader: false,
};

export const coreConstants = {
  coreLogin: 'CORE_LOGIN',
  startLoading: 'CORE_START_LOADING',
  stopLoading: 'CORE_STOP_LOADING',
  coreLogout: 'CORE_LOGOUT',
  coreStartGlobalLoader: 'coreStartGlobalLoader',
  coreStopGlobalLoader: 'coreStopGlobalLoader',
  coreTokenRefreshed: 'CORE_TOKEN_REFRESHED',
};

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case coreConstants.coreStartGlobalLoader: {
      return { ...state, globalLoader: true };
    }

    case coreConstants.coreStopGlobalLoader: {
      return { ...state, globalLoader: false };
    }

    case coreConstants.coreLogin: {
      const { token, user, refreshToken }: ILoginResponse = action.payload;
      localStorage.setItem(AUTH_TOKEN_KEY, token);
      localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
      if (refreshToken)
        localStorage.setItem(AUTH_REFRESH_TOKEN_KEY, refreshToken);
      return {
        ...state,
        user,
        token,
        isLoadingUser: false,
        splash: false,
      };
    }

    case coreConstants.coreTokenRefreshed: {
      const { token } = action.payload;
      localStorage.setItem(AUTH_TOKEN_KEY, token);
      return { ...state, token };
    }

    case coreConstants.coreLogout: {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      localStorage.removeItem(AUTH_USER_KEY);
      localStorage.removeItem(AUTH_REFRESH_TOKEN_KEY);
      return {
        ...state,
        user: null,
        isLoadingUser: false,
        splash: false,
      };
    }

    case coreConstants.stopLoading: {
      return { ...state, isLoadingUser: false };
    }
    case coreConstants.startLoading: {
      return { ...state, isLoadingUser: true };
    }
    default: {
      return state;
    }
  }
}
